import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type KpiDataObjectWithCategory } from '../types'

// What makes up this slice
export interface kpiDailyState {
  isLoading: boolean
  loadingError: string | null
  dataCompleteness: KpiDataObjectWithCategory | undefined
  httpStatus: number | null
}

// Initial state of the slice
const initialState: kpiDailyState = {
  isLoading: false,
  loadingError: null,
  dataCompleteness: undefined,
  httpStatus: null
}

// Slice to return from action
export const kpiDailySlice = createSlice({
  name: 'DataCompleteness',
  initialState,
  reducers: {
    kpiDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        dataCompleteness: undefined,
        httpStatus: 0
      }
    },
    kpiDataUpdateAction: (state, action: PayloadAction<{ kpiData: KpiDataObjectWithCategory, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        dataCompleteness: action.payload.kpiData,
        httpStatus: action.payload.httpStatus
      }
    },
    kpiDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        dataCompleteness: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  kpiDataLoadingAction,
  kpiDataUpdateAction,
  kpiDataErrorAction
} = kpiDailySlice.actions

export default kpiDailySlice.reducer
